// Validation Engine — React hook wrapper around the pure gate.
//
// The slice's gate is local/env only (no remote fetch yet — the
// validation_engine_flags table exists for future fleet control + edge
// functions). Recomputed each render; cheap and synchronous.

import { validationEngineGate, type ValidationGate } from './validationEngineFlag';

export function useValidationEngineGate(): ValidationGate {
  return validationEngineGate();
}
